import { render, staticRenderFns } from "./NovyDvor.vue?vue&type=template&id=5ccf1a5c&scoped=true"
import script from "./NovyDvor.vue?vue&type=script&lang=js"
export * from "./NovyDvor.vue?vue&type=script&lang=js"
import style0 from "./NovyDvor.vue?vue&type=style&index=0&id=5ccf1a5c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccf1a5c",
  null
  
)

export default component.exports